"use strict";
// CIP fork feature (see FORK.md): weval's composite model id for a run target,
// `provider:model[temp:t]` plus `[sp_idx:i]` when a blueprint has more than
// one system prompt (weval-org/app comparison-pipeline-service.non-stream.ts).
// A model that refuses a temperature reads `[temp:default]`: it answered at
// its provider's default, so it is a different series from `[temp:0]`.
// Platform models are reached through OpenRouter, so they read
// `openrouter:<model>` exactly as weval's own runs did and stay on one series
// with migrated history.
Object.defineProperty(exports, "__esModule", { value: true });
exports.connectionSlug = connectionSlug;
exports.effectiveModelId = effectiveModelId;
exports.endpointHost = endpointHost;
exports.freezeIdentity = freezeIdentity;
function connectionSlug(connection) {
    const slug = connection
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    return slug || "connection";
}
function effectiveModelId(params) {
    const provider = params.platform
        ? "openrouter"
        : connectionSlug(params.connection);
    const temp = params.temperatureSent === false ? "default" : params.temperature;
    let id = `${provider}:${params.model}[temp:${temp}]`;
    if (params.systemCount > 1 && params.systemIndex !== null) {
        id += `[sp_idx:${params.systemIndex}]`;
    }
    return id;
}
/** Host of a connection's base URL, never its path, query or credentials. */
function endpointHost(baseURL) {
    if (!baseURL)
        return null;
    try {
        return new URL(baseURL).host || null;
    }
    catch {
        return null;
    }
}
/** A target's identity as a run freezes it: no secrets, no headers. */
function freezeIdentity(params) {
    return {
        effectiveId: effectiveModelId({
            connection: params.connection.provider,
            model: params.target.model,
            platform: params.connection.platform,
            temperature: params.temperature,
            temperatureSent: params.temperatureSent,
            systemIndex: params.systemIndex,
            systemCount: params.systemCount,
        }),
        connection: params.connection.provider,
        adapter: params.connection.adapter,
        endpointHost: params.connection.platform
            ? null
            : endpointHost(params.connection.baseURL),
        model: params.target.model,
        platform: params.connection.platform,
        temperature: params.temperature,
        ...(params.temperatureSent !== undefined
            ? { temperatureSent: params.temperatureSent }
            : {}),
        systemIndex: params.systemIndex,
        ...(params.declared ? { declared: params.declared } : {}),
    };
}
